import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../../Navbar/Navbar';
import Stepper from '../Stepper/Stepper';
import ReactMarkdown from "react-markdown";
import { useGetAddOnQuery } from '../../../../Redux/Api/AuthApi';
import { useDispatch } from 'react-redux';
import { partBookingDetails } from '../../../../Redux/Slice/AuthSlice';

const AddOns = () => {
      const [slotData,setSlotData] = useState()
      const {data,isSuccess} = useGetAddOnQuery()
      const location = useLocation();
      const dispatch = useDispatch()
      const dataSlot = location.state;
      const navigate = useNavigate()
   
      console.log(dataSlot)

      useEffect(()=>{
        if(isSuccess){
          setSlotData(data?.data)
        }
      },[setSlotData,data,isSuccess])
      
    const handleAddOn = (data)=>{
     const addOn = {...data,dataSlot}
     dispatch(partBookingDetails(JSON.stringify({data:slotData,message:'addOn'})))
     navigate('/portal/booking/party/details',{state:addOn})
    }
  return (
    <div className="kiga-portal-package-main">
         <Navbar />
         <div className="kiga-portal-package-head-title">
          <p>Party Booking</p>
         </div>
         <Stepper/>
         <section className='kiga-portal-package-section'>
          <div className='kiga-portal-package-section-title'>
            <h5>step 4</h5>
            <p>Choose Add-ons</p>
          </div>
          {
            slotData?.map((el,index)=>(
           <div className='kiga-portal-package-section-card' key={index}>
            <div className='kiga-portal-package-section-card-content-image'>
            <div className='kiga-portal-package-section-card-image'>
              <img src='/images/Gallery/holiday.jpg' alt='slot-pc'/>
             </div>
            </div>
             <div className='kiga-portal-package-section-card-content'>
              <div className='kiga-portal-package-section-card-content-head'>
               <div>{el?.name}</div>
               <div><p>{el?.price} Rwf</p></div>
              </div>
              <div className='kiga-portal-package-section-card-content-info'>
                <ReactMarkdown>{el?.description}</ReactMarkdown>
              </div>
             <div className='kiga-portal-package-section-card-content-btn'>
                <button onClick={()=>handleAddOn(el)}>Select AddOn</button>
              </div>
             </div>
           </div>
            ))
          }
         </section>
        </div>
  )
}

export default AddOns